module.exports = __webpack_public_path__ + "translations/en/login.json";


//////////////////
// WEBPACK FOOTER
// ./translations/en/login.json
// module id = ./translations/en/login.json
// module chunks = 1